<template>
  <div class="transaction">
    <Text
      pattern="body2"
      :weight="500"
      :height="130"
      align="left"
      :textDecoration="value ? 'underline' : 'none'"
    >
      {{ value ? shorten(value) : "the-void" }}
    </Text>
    <!--    <Copy v-if="value" :value="value" />-->
  </div>
</template>

<script>
import { Text } from "@/shared/ui";
// import Copy from "@/features/Copy/ui/Copy.vue";
import { shorten } from "@/shared/utils/format";

export default {
  name: "Address",
  components: {
    Text,
    // Copy
  },
  props: {
    value: {
      type: String,
      default: "",
    },
  },

  methods: { shorten },
};
</script>

<style lang="scss" scoped>
.transaction {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 6px;
}
</style>
